/**
 * 챌린지 공개 범위(QBase setChallengeScope, 2026-10-07) — 화면이 보내기 전에 막을 것. 권위는 서버(400·403)다.
 *   ALL 전체 · GROUP 대상 그룹 구성원 · USER 지정 사용자 · PRIVATE 비공개(작성자·LSADMIN 만)
 * 대상 목록은 통째로 교체된다. GROUP 은 그룹 1개 이상, USER 는 사용자 1명 이상 · 200명까지.
 */
export const MAX_SCOPE_TARGETS = 200;

/** 「QUR0000137, USR0000087」 같은 입력 → usrid 목록(공백·쉼표·세미콜론·줄바꿈, 중복 제거) */
export function parseUsrids(text) {
    return [...new Set(String(text || '').split(/[\s,;]+/).map(s => s.trim()).filter(Boolean))];
}

/** 막을 것 — 오류 키(challenge:scope.err.*) 또는 null. 손대지 않은 범위는 보내지 않으므로 검사하지 않는다 */
export function scopeProblem(scope) {
    if (!scope || !scope.touched) return null;
    if (scope.code === 'GROUP' && !(scope.groupIds || []).length) return 'noGroup';
    if (scope.code === 'USER') {
        const n = parseUsrids(scope.usrids).length;
        if (!n) return 'noUser';
        if (n > MAX_SCOPE_TARGETS) return 'tooManyUsers';
    }
    return null;
}
